<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/awards"
      title="Lista nagród"
      :numeral_text="['nagroda', 'nagrody', 'nagród']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
